// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"0b5a70e0","488":"83e83a0f"}[chunkId] + ".chunk.js";
};